import {
    GETALLOWCOUNTRYLIST_SUCCESS,
    GETALLOWCOUNTRYLIST_FAILED,
    RESET_GETALLOWCOUNTRYLIST,
    LOADING_GETALLOWCOUNTRYLIST,
    NETWORK_ERROR_GETALLOWCOUNTRYLIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETALLOWCOUNTRYLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETALLOWCOUNTRYLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETALLOWCOUNTRYLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETALLOWCOUNTRYLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETALLOWCOUNTRYLIST:
            return (state = initialState);
        default:
            return state;
    }
};
